// extracted by mini-css-extract-plugin
module.exports = {"flag32":"CountrySelect_flag32__lJvTQ","card":"CountrySelect_card__xSVjC"};